import styled, {css} from "styled-components"

export const SwatchContainer = styled.div`
  height: fit-content;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto;
  grid-template-areas: "main";

  & > * {
    grid-area: main;
    place-self: center;
  }

  & > svg {
    pointer-events: none;
  }
`

export const Swatch = styled.input<{size?: number}>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  background-color: var(--wallet-budget-swatch);

  &:hover {
    outline: 2px solid var(--wallet-budget-swatch);
    outline-offset: 2px;
  }

  ${({size = 18}) => css`
    width: ${size}px;
    height: ${size}px;
  `}

  border: none;
  border-radius: 100px;

  &::-webkit-color-swatch {
    border-radius: 100px;
    border: none;
  }

  &::-moz-color-swatch {
    border-radius: 100px;
    border: none;
  }
`
